import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ReturnStruct } from 'src/app/shared/structs/return.struct';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { CommonService } from '../../common-service';
import { MessageHistoryResponse } from '../../responses/notification/message-history.response';
import { CsatResultRequest } from '../../requests/customer-success/csat-result.request';
import { CsatResultResponse } from '../../responses/orchestrator-user/csat-result.response';

@Injectable({
    providedIn: 'root'
})
export class CsatService extends CommonService {

    constructor(private router: Router, private httpClient: HttpClient, configService: AppConfigService, private endpointBuilder: EndpointBuilderService) {
        super(configService);
    }

    getResult(body: CsatResultRequest): Observable<CsatResultResponse> {
        let uri = `Csat`

        return this.httpClient.post<CsatResultResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiOrchestratorUser) + uri, body, this.addHeaderToken())
            .pipe(
                catchError(this.handleError)
            )
    }
}
